import React, { useEffect, useState, useMemo } from "react";
import { Box, Popover } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { GetCategories } from "../utils/categoryAPI";

// כמו ב-ProductList
const getParentId = (c) => c?.parentCategoryId ?? c?.parentCategoryID ?? null;

export default function CategoryGrid({
  src,
  hotspots = [],
  ratio = 0.5,
  maxWidth = 1200,
}) {
  const nav = useNavigate();

  // כל הקטגוריות
  const [categories, setCategories] = useState([]);

  // החלונית
  const [anchorEl, setAnchorEl] = useState(null);
  const [currentRootId, setCurrentRootId] = useState(null);

  useEffect(() => {
    GetCategories().then((data) => {
      const arr = Array.isArray(data) ? data : [];
      setCategories(arr);
      console.log("CATEGORIES FROM API:", arr);
    });
  }, []);

  const subCategories = useMemo(() => {
    if (!currentRootId) return [];
    return categories.filter((c) => {
      const parentId = getParentId(c);
      return parentId != null && parentId == currentRootId;
    });
  }, [categories, currentRootId]);

  useEffect(() => {
    console.log("currentRootId:", currentRootId);
    console.log("subCategories:", subCategories);
  }, [currentRootId, subCategories]);

  // כאן השינוי: מקבלים את כל ה-hotspot, לא categoryId
  const handleOpen = (event, hotspot) => {
    // מחפשים קטגוריה ראשית לפי השם שמופיע ב-label
    const rootCat = categories.find(
      (c) => c.nameCategor === hotspot.label
    );

    if (!rootCat) {
      console.warn("לא נמצאה קטגוריה עבור hotspot:", hotspot);
      return;
    }

    setCurrentRootId(rootCat.id);      // למשל 21 עבור "כלי כתיבה"
    setAnchorEl(event.currentTarget);

  };

  const handleClose = () => {
    setAnchorEl(null);
    setCurrentRootId(null);
  };

  const popoverOpen = Boolean(anchorEl);

  const handleGoToProducts = (subId) => {
    handleClose();
    nav(`/products/sub/${subId}`);
  };

  return (
    <Box sx={{ position: "relative", width: "100%", maxWidth, mx: "auto" }}>
      {/* שומר יחס */}
      <Box sx={{ position: "relative", width: "100%", pt: `${ratio * 100}%` }}>
        {/* התמונה */}
        <Box
          component="img"
          src={src}
          alt=""
          draggable={false}
          sx={{
            position: "absolute",
            inset: 0,
            width: "100%",
            height: "100%",
            objectFit: "cover",
            display: "block",
            userSelect: "none",
          }}
        />

        {/* Hotspots */}
        {hotspots.map((h) => (
          <Box
            key={h.id}
            component="button"
            aria-label={h.label || h.id}
            onClick={(e) => handleOpen(e, h)} 

            sx={{
              position: "absolute",
              left: `${h.x}%`,
              top: `${h.y}%`,
              width: `${h.w}%`,
              height: `${h.h}%`,
              background: "transparent",
              border: "none",
              padding: 0,
              cursor: "pointer",
            }}
          />
        ))}
      </Box>

      {/* חלונית תתי קטגוריות */}
      <Popover
        open={popoverOpen}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
        PaperProps={{
          sx: {
            p: 2,
            borderRadius: 2,
            minWidth: { xs: 320, md: 500 },
            maxWidth: 700,
            boxShadow: 6,
          },
        }}
      >
        <Box
          sx={{
            columnCount: { xs: 2, md: 3 },
            columnGap: 2,
            px: 1,
            py: 1,
          }}
        >
          {subCategories.length ? (
            subCategories.map((sub) => (
              <Box
                key={sub.id}
                onClick={() => handleGoToProducts(sub.id)}
                sx={{
                  breakInside: "avoid",
                  py: 0.5,
                  cursor: "pointer",
                  fontSize: 16,
                  fontWeight: 700,
                  color: "#D81B60",
                  "&:hover": { textDecoration: "underline" },
                }}
              >
                {sub.nameCategor}
              </Box>
            ))
          ) : (
            <Box sx={{ py: 1, fontSize: 15, color: "gray" }}>
              אין תתי קטגוריות לקטגוריה זו
            </Box>
          )}
        </Box>
      </Popover>
    </Box>
  );
}
